import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row gx-2" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "card h-100" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  class: "col-md-3",
  style: {"padding-bottom":"20px","text-align":"center"}
}
const _hoisted_7 = {
  class: "photo-circle",
  style: {"max-width":"190px"}
}
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = { class: "table table-borderless table-detail" }
const _hoisted_10 = /*#__PURE__*/_createVNode("th", null, "Nama", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("th", null, ":", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("th", null, "NIS", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("th", null, ":", -1)
const _hoisted_14 = {
  href: "javascript:void(0)",
  class: "no-pointer"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("th", null, "Sekolah", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("th", null, ":", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("th", null, "Kelas", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("th", null, ":", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("th", null, "Ayah", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("th", null, ":", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("th", null, "Ibu", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("th", null, ":", -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createVNode("th", null, "Telepon", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("th", null, ":", -1)
const _hoisted_26 = { class: "row gx-2 pt-2" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "card rounded-3 h-100 bg-gradient-primary text-white" }
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-icon m-3" }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "calendar-outline" })
  ])
], -1)
const _hoisted_32 = { class: "col-md-10" }
const _hoisted_33 = { class: "m-3" }
const _hoisted_34 = /*#__PURE__*/_createVNode("h5", null, "Tagihan", -1)
const _hoisted_35 = { class: "d-inline" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "card h-100" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "col-md-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-icon m-3 text-primary" }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "receipt-outline" })
  ])
], -1)
const _hoisted_41 = { class: "col-md-10" }
const _hoisted_42 = { class: "m-3" }
const _hoisted_43 = /*#__PURE__*/_createVNode("h5", null, "Riwayat Pembayaran", -1)
const _hoisted_44 = { class: "d-inline text-primary" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "btn btn-link-gray" }, [
  /*#__PURE__*/_createVNode("ion-icon", { name: "arrow-forward-circle-outline" })
], -1)
const _hoisted_46 = { class: "row pt-2" }
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "card" }
const _hoisted_49 = { class: "card-body" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = {
  key: 0,
  name: "card-outline"
}
const _hoisted_53 = {
  key: 1,
  class: "fa fa-spinner fa-pulse"
}
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Bayar SPP 1 tahun ")
const _hoisted_55 = {
  key: 1,
  class: "fw-bold mt-2"
}
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "float-end" }
const _hoisted_58 = { class: "d-inline" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", { for: "" }, "Tahun Ajar:", -1)
const _hoisted_60 = { class: "row pt-2" }
const _hoisted_61 = { class: "col-md-12" }
const _hoisted_62 = { class: "card" }
const _hoisted_63 = { class: "card-body" }
const _hoisted_64 = {
  key: 0,
  class: "nav nav-tabs",
  id: "billTabs",
  role: "tablist"
}
const _hoisted_65 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_66 = { class: "table table-borderless table-data fw-bold" }
const _hoisted_67 = /*#__PURE__*/_createVNode("th", null, "Nama Tagihan ", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("th", null, "Total Bayar ", -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("th", null, "Batas Pelunasan ", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("th", null, "Denda", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("th", null, "Status", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("th", null, null, -1)
const _hoisted_73 = {
  key: 0,
  class: "form-check"
}
const _hoisted_74 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, [
  /*#__PURE__*/_createVNode("a", {
    href: "javascript:void(0)",
    class: "btn btn-link-gray no-pointer"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "newspaper-outline" })
  ])
], -1)
const _hoisted_75 = { class: "badge bg-info" }
const _hoisted_76 = { class: "text-primary" }
const _hoisted_77 = { class: "text-danger" }
const _hoisted_78 = {
  key: 0,
  class: "btn btn-sm btn-outline-success rounded-pill no-pointer"
}
const _hoisted_79 = {
  key: 1,
  class: "btn btn-sm btn-outline-success rounded-pill no-pointer"
}
const _hoisted_80 = {
  key: 2,
  class: "btn btn-sm btn-outline-warning rounded-pill no-pointer"
}
const _hoisted_81 = {
  key: 3,
  class: "btn btn-sm btn-outline-warning rounded-pill no-pointer"
}
const _hoisted_82 = {
  key: 4,
  class: "btn btn-sm btn-outline-info rounded-pill no-pointer"
}
const _hoisted_83 = {
  key: 5,
  class: "btn btn-sm btn-outline-info rounded-pill no-pointer"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("ion-icon", { name: "information-circle-outline" }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" Detail ")
const _hoisted_86 = { key: 0 }
const _hoisted_87 = {
  key: 0,
  name: "card-outline"
}
const _hoisted_88 = {
  key: 1,
  class: "fa fa-spinner fa-pulse"
}
const _hoisted_89 = /*#__PURE__*/_createTextVNode(" Bayar ")
const _hoisted_90 = /*#__PURE__*/_createVNode("ion-icon", { name: "reader-outline" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Invoice ")
const _hoisted_92 = { key: 1 }
const _hoisted_93 = {
  key: 0,
  name: "card-outline"
}
const _hoisted_94 = {
  key: 1,
  class: "fa fa-spinner fa-pulse"
}
const _hoisted_95 = /*#__PURE__*/_createTextVNode(" Bayar ")
const _hoisted_96 = /*#__PURE__*/_createVNode("ion-icon", { name: "reader-outline" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createTextVNode(" Invoice ")
const _hoisted_98 = /*#__PURE__*/_createVNode("ion-icon", { name: "refresh-circle-outline" }, null, -1)
const _hoisted_99 = /*#__PURE__*/_createTextVNode(" Refund ")
const _hoisted_100 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-12\"><ol class=\"horizontal-list\"><li class=\"horizontal-list-item white\"> Belum masuk tenggat waktu </li><li class=\"horizontal-list-item orange\"> Mendekati tenggat waktu </li><li class=\"horizontal-list-item red\"> Melewati tenggat waktu </li></ol></div></div>", 1)
const _hoisted_101 = {
  key: 0,
  class: "row pt-2"
}
const _hoisted_102 = { class: "col-md-12" }
const _hoisted_103 = { class: "card h-100" }
const _hoisted_104 = { class: "card-body" }
const _hoisted_105 = {
  class: "m-3",
  style: {"display":"flex","justify-content":"space-between","align-items":"center"}
}
const _hoisted_106 = /*#__PURE__*/_createVNode("h5", { class: "text-secondary" }, "Total Tagihan Dipilih", -1)
const _hoisted_107 = { style: {"margin-top":"-5px","font-size":"10pt"} }
const _hoisted_108 = {
  key: 0,
  name: "card-outline"
}
const _hoisted_109 = {
  key: 1,
  class: "fa fa-spinner fa-pulse"
}
const _hoisted_110 = /*#__PURE__*/_createTextVNode(" Bayar Terpilih ")
const _hoisted_111 = {
  id: "billDetailModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_112 = { class: "modal-dialog modal-lg" }
const _hoisted_113 = { class: "modal-content" }
const _hoisted_114 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Detail Tagihan"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_115 = { class: "modal-body" }
const _hoisted_116 = { class: "row g-3" }
const _hoisted_117 = { class: "col-12" }
const _hoisted_118 = { class: "col-md-6 mb-3" }
const _hoisted_119 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Tahun Ajar", -1)
const _hoisted_120 = { class: "btn btn-block btn-outline-secondary rounded-pill no-pointer" }
const _hoisted_121 = { class: "col-md-6 mb-3" }
const _hoisted_122 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Bulan Pembayaran", -1)
const _hoisted_123 = { class: "btn btn-block btn-outline-secondary rounded-pill no-pointer" }
const _hoisted_124 = { class: "col-md-12 mb-3" }
const _hoisted_125 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label text-primary"
}, "Detail Biaya", -1)
const _hoisted_126 = { class: "table" }
const _hoisted_127 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { colspan: "3" }, "Rincian Biaya")
  ])
], -1)
const _hoisted_128 = { key: 0 }
const _hoisted_129 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createVNode("span", { class: "text-success" }, "+")
], -1)
const _hoisted_130 = /*#__PURE__*/_createVNode("td", null, "Denda", -1)
const _hoisted_131 = /*#__PURE__*/_createVNode("td", {
  colspan: "2",
  class: "fw-bold"
}, "TOTAL", -1)
const _hoisted_132 = { class: "fw-bold" }
const _hoisted_133 = { class: "col-12 row" }
const _hoisted_134 = { class: "col-md-4" }
const _hoisted_135 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label text-primary"
}, "Denda", -1)
const _hoisted_136 = { class: "badge bg-info" }
const _hoisted_137 = { key: 0 }
const _hoisted_138 = { key: 1 }
const _hoisted_139 = { class: "col-md-4" }
const _hoisted_140 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label text-primary"
}, "Tanggal Pengingat", -1)
const _hoisted_141 = { class: "col-md-4" }
const _hoisted_142 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label text-primary"
}, "Batas Tanggal", -1)
const _hoisted_143 = {
  key: 0,
  class: "col-12 row"
}
const _hoisted_144 = { class: "col-md-4" }
const _hoisted_145 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label text-primary"
}, "Denda Lewat Bulan", -1)
const _hoisted_146 = { class: "badge bg-info" }
const _hoisted_147 = { key: 0 }
const _hoisted_148 = { key: 1 }
const _hoisted_149 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("label", {
    for: "",
    class: "form-label text-primary"
  }),
  /*#__PURE__*/_createVNode("h4")
], -1)
const _hoisted_150 = { class: "col-md-4" }
const _hoisted_151 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label text-primary"
}, "Batas Tanggal", -1)
const _hoisted_152 = { class: "col-md-12" }
const _hoisted_153 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label text-primary"
}, "Keterangan", -1)
const _hoisted_154 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)
const _hoisted_155 = {
  id: "convenienceFeeModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_156 = { class: "modal-dialog modal-lg" }
const _hoisted_157 = { class: "modal-content" }
const _hoisted_158 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Pilih Metode Pembayaran"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_159 = { class: "modal-body" }
const _hoisted_160 = { class: "row g-3" }
const _hoisted_161 = { class: "col-md-12 mb-3" }
const _hoisted_162 = { class: "text-secondary d-inline" }
const _hoisted_163 = /*#__PURE__*/_createVNode("ion-icon", { name: "arrow-back-outline" }, null, -1)
const _hoisted_164 = /*#__PURE__*/_createTextVNode(" Kembali ")
const _hoisted_165 = { class: "col-md-12 mb-3" }
const _hoisted_166 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Nominal", -1)
const _hoisted_167 = { class: "col-md-12 mb-3" }
const _hoisted_168 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Biaya Admin", -1)
const _hoisted_169 = { class: "col-md-12 mb-3" }
const _hoisted_170 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Biaya Merchant", -1)
const _hoisted_171 = { class: "col-md-12 mb-3" }
const _hoisted_172 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Potongan Harga", -1)
const _hoisted_173 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_174 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "PPN", -1)
const _hoisted_175 = { class: "col-md-12 mb-3" }
const _hoisted_176 = /*#__PURE__*/_createVNode("label", {
  for: "",
  class: "form-label"
}, "Total Bayar", -1)
const _hoisted_177 = { class: "modal-footer" }
const _hoisted_178 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
  /*#__PURE__*/_createTextVNode(" Tutup")
], -1)
const _hoisted_179 = {
  key: 0,
  name: "card-outline"
}
const _hoisted_180 = {
  key: 1,
  class: "fa fa-spinner fa-pulse"
}
const _hoisted_181 = /*#__PURE__*/_createTextVNode(" Bayar ")
const _hoisted_182 = {
  id: "xenditModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_183 = { class: "modal-dialog modal-lg" }
const _hoisted_184 = { class: "modal-content" }
const _hoisted_185 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Pembayaran"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_186 = { class: "modal-body" }
const _hoisted_187 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)
const _hoisted_188 = {
  id: "bcaModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_189 = { class: "modal-dialog modal-lg" }
const _hoisted_190 = { class: "modal-content" }
const _hoisted_191 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Pembayaran"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_192 = { class: "modal-body" }
const _hoisted_193 = { style: {"width":"100%"} }
const _hoisted_194 = { key: 0 }
const _hoisted_195 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Order Id", -1)
const _hoisted_196 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_197 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_198 = { key: 1 }
const _hoisted_199 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "No Invoice", -1)
const _hoisted_200 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_201 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_202 = {
  key: 0,
  style: {"padding":"10px"}
}
const _hoisted_203 = {
  key: 1,
  style: {"padding":"10px"}
}
const _hoisted_204 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_205 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_206 = { key: 2 }
const _hoisted_207 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Nomor Va 2", -1)
const _hoisted_208 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_209 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_210 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Total Biaya", -1)
const _hoisted_211 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_212 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_213 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Biaya Admin", -1)
const _hoisted_214 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_215 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_216 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Biaya Merchant", -1)
const _hoisted_217 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_218 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_219 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Total Diskon", -1)
const _hoisted_220 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_221 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_222 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "PPN", -1)
const _hoisted_223 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_224 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_225 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, [
  /*#__PURE__*/_createVNode("b", null, "Total Bayar")
], -1)
const _hoisted_226 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, [
  /*#__PURE__*/_createVNode("b", null, " : ")
], -1)
const _hoisted_227 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_228 = { key: 0 }
const _hoisted_229 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_230 = /*#__PURE__*/_createVNode("label", {
  for: "referenceFile",
  class: "form-label"
}, "Bukti Pembayaran", -1)
const _hoisted_231 = { class: "text-center mt-2" }
const _hoisted_232 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_233 = {
  key: 1,
  class: "alert alert-warning mt-2",
  role: "alert"
}
const _hoisted_234 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)
const _hoisted_235 = {
  id: "refundModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_236 = { class: "modal-dialog modal-lg" }
const _hoisted_237 = { class: "modal-content" }
const _hoisted_238 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Refund Detail"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_239 = { class: "modal-body" }
const _hoisted_240 = { class: "table table-bordered" }
const _hoisted_241 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "Nama Tagihan"),
    /*#__PURE__*/_createVNode("th", null, "Bulan"),
    /*#__PURE__*/_createVNode("th", null, "Status"),
    /*#__PURE__*/_createVNode("th", null, "Nominal Refund")
  ])
], -1)
const _hoisted_242 = { class: "badge bg-info" }
const _hoisted_243 = /*#__PURE__*/_createVNode("td", {
  colspan: "3",
  class: "text-end fw-bold"
}, "Total Refund", -1)
const _hoisted_244 = { class: "fw-bold" }
const _hoisted_245 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, "Close")
], -1)
const _hoisted_246 = {
  id: "importedVAModal",
  class: "modal",
  tabindex: "-1"
}
const _hoisted_247 = { class: "modal-dialog modal-lg" }
const _hoisted_248 = { class: "modal-content" }
const _hoisted_249 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Pembayaran"),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_250 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_251 = { style: {"width":"100%"} }
const _hoisted_252 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Order Id", -1)
const _hoisted_253 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_254 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_255 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, "Nomor Va", -1)
const _hoisted_256 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, " : ", -1)
const _hoisted_257 = { style: {"text-transform":"capitalize","text-align":"right","padding":"10px"} }
const _hoisted_258 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, [
  /*#__PURE__*/_createVNode("b", null, "Total Bayar")
], -1)
const _hoisted_259 = /*#__PURE__*/_createVNode("td", { style: {"padding":"10px"} }, [
  /*#__PURE__*/_createVNode("b", null, " : ")
], -1)
const _hoisted_260 = { style: {"text-align":"right","padding":"10px"} }
const _hoisted_261 = { key: 1 }
const _hoisted_262 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_263 = { class: "mb-3" }
const _hoisted_264 = /*#__PURE__*/_createVNode("label", {
  for: "referenceFile",
  class: "form-label"
}, "Bukti Pembayaran", -1)
const _hoisted_265 = { class: "text-center mt-2" }
const _hoisted_266 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_267 = {
  key: 1,
  class: "alert alert-warning mt-2",
  role: "alert"
}
const _hoisted_268 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-outline-secondary",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createVNode("ion-icon", { name: "close-outline" }),
    /*#__PURE__*/_createTextVNode(" Tutup")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_router_link = _resolveComponent("router-link")
  const _component_CurrencyInputDisable = _resolveComponent("CurrencyInputDisable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      title: "Daftar Tagihan Siswa",
      link1: "Tagihan",
      link2: _ctx.user.name
    }, null, 8, ["link2"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("img", {
                    onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onImageLoadFailure($event))),
                    src: _ctx.imagepath,
                    alt: ""
                  }, null, 40, ["src"])
                ])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("table", _hoisted_9, [
                  _createVNode("tr", null, [
                    _hoisted_10,
                    _hoisted_11,
                    _createVNode("td", null, _toDisplayString(_ctx.user.name), 1)
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode("td", null, [
                      _createVNode("a", _hoisted_14, _toDisplayString(_ctx.user.student_profile_nis), 1)
                    ])
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_15,
                    _hoisted_16,
                    _createVNode("td", null, _toDisplayString(_ctx.school.name), 1)
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_17,
                    _hoisted_18,
                    _createVNode("td", null, _toDisplayString(_ctx.user.class_name), 1)
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_19,
                    _hoisted_20,
                    _createVNode("td", null, _toDisplayString(_ctx.user.parent_father), 1)
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_21,
                    _hoisted_22,
                    _createVNode("td", null, _toDisplayString(_ctx.user.parent_mother), 1)
                  ]),
                  (_ctx.isHideElementYkck)
                    ? (_openBlock(), _createBlock("tr", _hoisted_23, [
                        _hoisted_24,
                        _hoisted_25,
                        _createVNode("td", null, _toDisplayString(_ctx.user.user_profile_no_hp), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode("div", _hoisted_27, [
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("div", _hoisted_32, [
                _createVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode("h3", _hoisted_35, "Rp" + _toDisplayString(_ctx.toLocaleString((_ctx.stats.total_bill-_ctx.stats.total_paid))), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_36, [
        _createVNode(_component_router_link, { to: "/user/payment" }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_37, [
              _createVNode("div", _hoisted_38, [
                _createVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode("div", _hoisted_41, [
                    _createVNode("div", _hoisted_42, [
                      _hoisted_43,
                      _createVNode("h3", _hoisted_44, _toDisplayString(_ctx.billCount), 1),
                      _hoisted_45
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_46, [
      _createVNode("div", _hoisted_47, [
        _createVNode("div", _hoisted_48, [
          _createVNode("div", _hoisted_49, [
            _createVNode("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                (_ctx.setting.UANGSEKOLAH_DISCOUNT_SETTING == 'full_year_payment_discount_smak1penabur')
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: [{'disabled': (_ctx.loadingYear)}, "d-inline btn btn-lg btn-warning"],
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.oneYearCheckout()))
                    }, [
                      (_ctx.loadingYear == false)
                        ? (_openBlock(), _createBlock("ion-icon", _hoisted_52))
                        : (_openBlock(), _createBlock("i", _hoisted_53)),
                      _hoisted_54
                    ], 2))
                  : _createCommentVNode("", true),
                (_ctx.sppPromoAnnuallyPaymentPercentage > 0)
                  ? (_openBlock(), _createBlock("label", _hoisted_55, "Potongan harga " + _toDisplayString(_ctx.sppPromoAnnuallyPaymentPercentage) + "% untuk pembayaran 1 tahun", 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_56, [
                _createVNode("div", _hoisted_57, [
                  _createVNode("div", _hoisted_58, [
                    _hoisted_59,
                    _withDirectives(_createVNode("select", {
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadData())),
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.param.school_year_id = $event)),
                      class: "d-inline text-primary form-select form-select-noborder"
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.schoolYears, (sy) => {
                        return (_openBlock(), _createBlock("option", {
                          key: sy.school_year_id,
                          label: sy.name,
                          value: sy.school_year_id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, _ctx.param.school_year_id]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_60, [
      _createVNode("div", _hoisted_61, [
        _createVNode("div", _hoisted_62, [
          _createVNode("div", _hoisted_63, [
            (_ctx.groupBillAsTab === true)
              ? (_openBlock(), _createBlock("ul", _hoisted_64, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billTypes, (type, index) => {
                    return (_openBlock(), _createBlock("li", {
                      key: index,
                      class: "nav-item",
                      role: "presentation"
                    }, [
                      _createVNode("a", {
                        class: ["nav-link", {'active' : index == 0}],
                        id: type.id+'-tab',
                        "data-bs-toggle": "tab",
                        "aria-current": "page",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.uncheckAllBill())),
                        href: '#'+type.id,
                        role: "tab",
                        "aria-controls": type.id,
                        "aria-selected": "true"
                      }, _toDisplayString(type.name), 11, ["id", "href", "aria-controls"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_65, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.billTypes, (type, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: ["tab-pane fade table-responsive", {'show active' : index == 0}],
                  key: index,
                  id: type.id,
                  role: "tabpanel",
                  "aria-labelledby": type.id+'-tab'
                }, [
                  _createVNode("table", _hoisted_66, [
                    _createVNode("thead", null, [
                      _createVNode("tr", null, [
                        _createVNode("th", null, [
                          (_ctx.stats.allow_mass_checkout && _ctx.useImportVA == false && _ctx.disableCheckboxes == 'false')
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 0,
                                class: "form-check-input",
                                type: "checkbox",
                                value: "",
                                onClick: ($event: any) => (_ctx.checkAllBill(type.id)),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.allSelectedBill = $event))
                              }, null, 8, ["onClick"])), [
                                [_vModelCheckbox, _ctx.allSelectedBill]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_67,
                        _hoisted_68,
                        _hoisted_69,
                        _hoisted_70,
                        _hoisted_71,
                        _hoisted_72
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userBills.filter(
                    // (bill) => bill.bill.spp_bill_type_id == type.id
                    (bill) => _ctx.groupBillAsTab === true ? bill.bill.spp_bill_type_id == type.id : true
                    ), (detail, i) => {
                        return (_openBlock(), _createBlock("tr", {
                          class: _ctx.tableDataClass(detail.due_date, detail.deadline_date, detail.status),
                          key: i
                        }, [
                          _createVNode("td", null, [
                            (_ctx.disableCheckboxes == 'false')
                              ? (_openBlock(), _createBlock("div", _hoisted_73, [
                                  (((detail.status == _ctx.constants.BILL_PENDING || detail.status == _ctx.constants.BILL_UNPAID) && (detail.spp_order_ids == undefined || _ctx.isCanceled(detail.spp_order_ids))) && (_ctx.stats.allow_mass_checkout && _ctx.useImportVA == false))
                                    ? _withDirectives((_openBlock(), _createBlock("input", {
                                        key: 0,
                                        class: "form-check-input",
                                        type: "checkbox",
                                        value: detail.id,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.billIds = $event))
                                      }, null, 8, ["value"])), [
                                        [_vModelCheckbox, _ctx.billIds]
                                      ])
                                    : _createCommentVNode("", true),
                                  _hoisted_74
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("td", null, [
                            _createTextVNode(_toDisplayString(detail.bill.name) + " ", 1),
                            _createVNode("span", _hoisted_75, _toDisplayString(_ctx.getMonth(detail.id)), 1)
                          ]),
                          _createVNode("td", _hoisted_76, " Rp" + _toDisplayString(_ctx.toLocaleString(detail.total_payment)), 1),
                          _createVNode("td", null, _toDisplayString(_ctx.beautifyDate(detail.deadline_date)), 1),
                          _createVNode("td", _hoisted_77, " Rp" + _toDisplayString(_ctx.toLocaleString(detail.late_charge)), 1),
                          _createVNode("td", null, [
                            (detail.status == _ctx.constants.BILL_PAID)
                              ? (_openBlock(), _createBlock("div", _hoisted_78, "LUNAS"))
                              : _createCommentVNode("", true),
                            (detail.status == _ctx.constants.BILL_OVERPAID)
                              ? (_openBlock(), _createBlock("div", _hoisted_79, "KELEBIHAN"))
                              : _createCommentVNode("", true),
                            (detail.status == _ctx.constants.BILL_PENDING)
                              ? (_openBlock(), _createBlock("div", _hoisted_80, "AKTIF"))
                              : _createCommentVNode("", true),
                            (detail.status == _ctx.constants.BILL_UNPAID)
                              ? (_openBlock(), _createBlock("div", _hoisted_81, "BELUM BAYAR"))
                              : _createCommentVNode("", true),
                            (detail.status == _ctx.constants.BILL_REFUNDED)
                              ? (_openBlock(), _createBlock("div", _hoisted_82, "REFUNDED"))
                              : _createCommentVNode("", true),
                            (detail.status == _ctx.constants.BILL_PARTIAL_REFUND)
                              ? (_openBlock(), _createBlock("div", _hoisted_83, "REFUND SEBAGIAN"))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("a", {
                              class: "btn btn-light text-secondary mr-1",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.detailBill(detail.id))
                            }, [
                              _hoisted_84,
                              _hoisted_85
                            ], 8, ["onClick"]),
                            (_ctx.useImportVA)
                              ? (_openBlock(), _createBlock("div", _hoisted_86, [
                                  ((detail.status == _ctx.constants.BILL_PENDING || detail.status == _ctx.constants.BILL_UNPAID) || _ctx.isCanceled(detail.spp_order_ids))
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        href: "javascript:void(0)",
                                        class: [{'disabled': (_ctx.loading[detail.id]) }, "btn btn-warning"],
                                        onClick: ($event: any) => (_ctx.showImportedVA(detail.spp_order_ids[0]))
                                      }, [
                                        (_ctx.loading[detail.id] != true)
                                          ? (_openBlock(), _createBlock("ion-icon", _hoisted_87))
                                          : _createCommentVNode("", true),
                                        (_ctx.loading[detail.id] == true)
                                          ? (_openBlock(), _createBlock("i", _hoisted_88))
                                          : _createCommentVNode("", true),
                                        _hoisted_89
                                      ], 10, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  ((detail.status == _ctx.constants.BILL_PAID || detail.status == _ctx.constants.BILL_OVERPAID) && !_ctx.isCanceled(detail.spp_order_ids))
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 1,
                                        href: "javascript:void(0)",
                                        class: "btn btn-warning",
                                        onClick: ($event: any) => (_ctx.invoice(detail.spp_order_ids[0]))
                                      }, [
                                        _hoisted_90,
                                        _hoisted_91
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_92, [
                                  ((detail.status == _ctx.constants.BILL_PENDING || detail.status == _ctx.constants.BILL_UNPAID) && (detail.spp_order_ids == undefined || _ctx.isCanceled(detail.spp_order_ids)))
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        href: "javascript:void(0)",
                                        class: [{'disabled': (_ctx.loading[detail.id]) }, "btn btn-warning"],
                                        onClick: ($event: any) => (_ctx.checkout(detail.id, detail.spp_order_ids))
                                      }, [
                                        (_ctx.loading[detail.id] != true)
                                          ? (_openBlock(), _createBlock("ion-icon", _hoisted_93))
                                          : _createCommentVNode("", true),
                                        (_ctx.loading[detail.id] == true)
                                          ? (_openBlock(), _createBlock("i", _hoisted_94))
                                          : _createCommentVNode("", true),
                                        _hoisted_95
                                      ], 10, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  ((detail.status == _ctx.constants.BILL_PAID || detail.status == _ctx.constants.BILL_OVERPAID) || (detail.spp_order_ids && !_ctx.isCanceled(detail.spp_order_ids)))
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 1,
                                        href: "javascript:void(0)",
                                        class: "btn btn-warning",
                                        onClick: ($event: any) => (_ctx.invoice(detail.spp_order_ids[0]))
                                      }, [
                                        _hoisted_96,
                                        _hoisted_97
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])),
                            (detail.status == _ctx.constants.BILL_REFUNDED || detail.status == _ctx.constants.BILL_PARTIAL_REFUND)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 2,
                                  href: "javascript:void(0)",
                                  class: "btn btn-info text-white",
                                  onClick: ($event: any) => (_ctx.openRefundModal(detail.id))
                                }, [
                                  _hoisted_98,
                                  _hoisted_99
                                ], 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ], 10, ["id", "aria-labelledby"]))
              }), 128))
            ]),
            _hoisted_100
          ])
        ])
      ])
    ]),
    (_ctx.disableCheckboxes == 'false' && _ctx.useImportVA == false && _ctx.stats.allow_mass_checkout)
      ? (_openBlock(), _createBlock("div", _hoisted_101, [
          _createVNode("div", _hoisted_102, [
            _createVNode("div", _hoisted_103, [
              _createVNode("div", _hoisted_104, [
                _createVNode("div", _hoisted_105, [
                  _createVNode("div", null, [
                    _hoisted_106,
                    _createVNode("h3", {
                      class: "d-inline text-primary fw-bold",
                      innerHTML: _ctx.totalSelectedAmount
                    }, null, 8, ["innerHTML"]),
                    _createVNode("h5", _hoisted_107, _toDisplayString(_ctx.promoTerm), 1)
                  ]),
                  _createVNode("div", null, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      class: [{'disabled': (_ctx.billIds.length == 0 || _ctx.loadingBulk)}, "d-inline btn btn-lg btn-warning float-end"],
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.bulkCheckout()))
                    }, [
                      (_ctx.loadingBulk == false)
                        ? (_openBlock(), _createBlock("ion-icon", _hoisted_108))
                        : (_openBlock(), _createBlock("i", _hoisted_109)),
                      _hoisted_110
                    ], 2)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_111, [
      _createVNode("div", _hoisted_112, [
        _createVNode("div", _hoisted_113, [
          _hoisted_114,
          _createVNode("div", _hoisted_115, [
            _createVNode("form", _hoisted_116, [
              _createVNode("div", _hoisted_117, [
                _createVNode("h3", null, _toDisplayString(_ctx.data.bill_name), 1)
              ]),
              _createVNode("div", _hoisted_118, [
                _hoisted_119,
                _createVNode("div", null, [
                  _createVNode("button", _hoisted_120, _toDisplayString(_ctx.data.school_year_name), 1)
                ])
              ]),
              _createVNode("div", _hoisted_121, [
                _hoisted_122,
                _createVNode("div", null, [
                  _createVNode("button", _hoisted_123, _toDisplayString(_ctx.data.month_name), 1)
                ])
              ]),
              _createVNode("div", _hoisted_124, [
                _hoisted_125,
                _createVNode("table", _hoisted_126, [
                  _hoisted_127,
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.details, (detail) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: detail.id
                      }, [
                        _createVNode("td", null, [
                          _createVNode("span", {
                            class: { 'text-success': detail.bill_detail.operation == '+', 'text-danger': detail.bill_detail.operation == '-' }
                          }, _toDisplayString(detail.bill_detail.operation), 3)
                        ]),
                        _createVNode("td", null, _toDisplayString(detail.bill_detail.name), 1),
                        _createVNode("td", null, "Rp" + _toDisplayString(_ctx.toLocaleString(detail.amount)), 1)
                      ]))
                    }), 128)),
                    (_ctx.data.late_charge > 0)
                      ? (_openBlock(), _createBlock("tr", _hoisted_128, [
                          _hoisted_129,
                          _hoisted_130,
                          _createVNode("td", null, "Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.data.late_charge)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("tfoot", null, [
                    _createVNode("tr", null, [
                      _hoisted_131,
                      _createVNode("td", _hoisted_132, "Rp" + _toDisplayString(_ctx.toLocaleString(_ctx.data.total_payment)), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_133, [
                _createVNode("div", _hoisted_134, [
                  _hoisted_135,
                  _createVNode("h5", null, [
                    _createTextVNode(_toDisplayString(_ctx.data.fine_rules.percentage) + " ", 1),
                    _createVNode("span", _hoisted_136, _toDisplayString(_ctx.data.fine_rules.formula), 1),
                    _createVNode("small", null, [
                      (_ctx.data.fine_rules.type == 'nominal')
                        ? (_openBlock(), _createBlock("span", _hoisted_137, "Rp"))
                        : _createCommentVNode("", true),
                      _createTextVNode(" (" + _toDisplayString(_ctx.toLocaleString(_ctx.data.fine_rules.value)) + ") ", 1),
                      (_ctx.data.fine_rules.type == 'percentage')
                        ? (_openBlock(), _createBlock("span", _hoisted_138, "%"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_139, [
                  _hoisted_140,
                  _createVNode("h4", null, _toDisplayString(_ctx.data.due_date), 1)
                ]),
                _createVNode("div", _hoisted_141, [
                  _hoisted_142,
                  _createVNode("h4", null, _toDisplayString(_ctx.data.deadline_date), 1)
                ])
              ]),
              (_ctx.data.fine_rules.late_month_fine.value > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_143, [
                    _createVNode("div", _hoisted_144, [
                      _hoisted_145,
                      _createVNode("h5", null, [
                        _createTextVNode(_toDisplayString(_ctx.data.fine_rules.late_month_fine.percentage) + " ", 1),
                        _createVNode("span", _hoisted_146, _toDisplayString(_ctx.data.fine_rules.late_month_fine.formula), 1),
                        _createVNode("small", null, [
                          (_ctx.data.fine_rules.late_month_fine.type == 'nominal')
                            ? (_openBlock(), _createBlock("span", _hoisted_147, "Rp"))
                            : _createCommentVNode("", true),
                          _createTextVNode(" (" + _toDisplayString(_ctx.toLocaleString(_ctx.data.fine_rules.late_month_fine.value)) + ") ", 1),
                          (_ctx.data.fine_rules.late_month_fine.type == 'percentage')
                            ? (_openBlock(), _createBlock("span", _hoisted_148, "%"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _hoisted_149,
                    _createVNode("div", _hoisted_150, [
                      _hoisted_151,
                      _createVNode("h4", null, _toDisplayString(_ctx.data.last_date), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_152, [
                _hoisted_153,
                _createVNode("p", null, _toDisplayString(_ctx.data.description), 1)
              ])
            ])
          ]),
          _hoisted_154
        ])
      ])
    ]),
    _createVNode("div", _hoisted_155, [
      _createVNode("div", _hoisted_156, [
        _createVNode("div", _hoisted_157, [
          _hoisted_158,
          _createVNode("div", _hoisted_159, [
            _createVNode("form", _hoisted_160, [
              (_ctx.paymentMethod)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.convenienceFee, (value, key) => {
                    return (_openBlock(), _createBlock("div", { key: key }, [
                      _withDirectives(_createVNode("input", {
                        type: "radio",
                        class: "btn-check",
                        value: value.id,
                        name: value.name,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.convenience_id = $event))
                      }, null, 8, ["value", "name"]), [
                        [_vModelRadio, _ctx.convenience_id]
                      ]),
                      _createVNode("label", {
                        class: "btn btn-outline-primary w-100",
                        onClick: ($event: any) => (_ctx.handleConvenienceFee(value.id))
                      }, _toDisplayString(value.name), 9, ["onClick"])
                    ]))
                  }), 128))
                : _createCommentVNode("", true),
              (!_ctx.paymentMethod)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_161, [
                      _createVNode("b", _hoisted_162, [
                        _createVNode("button", {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.paymentMethod = true)),
                          class: "btn btn-light btn-sm rounded-pill"
                        }, [
                          _hoisted_163
                        ]),
                        _hoisted_164
                      ])
                    ]),
                    _createVNode("div", _hoisted_165, [
                      _hoisted_166,
                      _createVNode(_component_CurrencyInputDisable, {
                        modelValue: _ctx.payment.amount,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.payment.amount = $event)),
                        options: _ctx.config
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createVNode("div", _hoisted_167, [
                      _hoisted_168,
                      _createVNode(_component_CurrencyInputDisable, {
                        modelValue: _ctx.payment.convenience_fee,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.payment.convenience_fee = $event)),
                        options: _ctx.config
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createVNode("div", _hoisted_169, [
                      _hoisted_170,
                      _createVNode(_component_CurrencyInputDisable, {
                        modelValue: _ctx.payment.merchant_fee,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.payment.merchant_fee = $event)),
                        options: _ctx.config
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createVNode("div", _hoisted_171, [
                      _hoisted_172,
                      _createVNode(_component_CurrencyInputDisable, {
                        modelValue: _ctx.payment.total_discount,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.payment.total_discount = $event)),
                        options: _ctx.config
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    (_ctx.payment.ppn > 0)
                      ? (_openBlock(), _createBlock("div", _hoisted_173, [
                          _hoisted_174,
                          _createVNode(_component_CurrencyInputDisable, {
                            modelValue: _ctx.payment.ppn,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.payment.ppn = $event)),
                            options: _ctx.config
                          }, null, 8, ["modelValue", "options"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_175, [
                      _hoisted_176,
                      _createVNode(_component_CurrencyInputDisable, {
                        modelValue: _ctx.payment.total_amount,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.payment.total_amount = $event)),
                        options: _ctx.config
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_177, [
            _hoisted_178,
            (!_ctx.paymentMethod)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  disabled: _ctx.loadingBulk,
                  class: "btn btn-primary",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkOutConvenience()))
                }, [
                  (!_ctx.loadingBulk)
                    ? (_openBlock(), _createBlock("ion-icon", _hoisted_179))
                    : (_openBlock(), _createBlock("i", _hoisted_180)),
                  _hoisted_181
                ], 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_182, [
      _createVNode("div", _hoisted_183, [
        _createVNode("div", _hoisted_184, [
          _hoisted_185,
          _createVNode("div", _hoisted_186, [
            (_ctx.xenditInvoice != '')
              ? (_openBlock(), _createBlock("iframe", {
                  key: 0,
                  src: _ctx.xenditInvoice,
                  frameborder: "0",
                  width: "100%",
                  height: "700"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_187
        ])
      ])
    ]),
    _createVNode("div", _hoisted_188, [
      _createVNode("div", _hoisted_189, [
        _createVNode("div", _hoisted_190, [
          _hoisted_191,
          _createVNode("div", _hoisted_192, [
            _createVNode("table", _hoisted_193, [
              (_ctx.bca.orderId)
                ? (_openBlock(), _createBlock("tr", _hoisted_194, [
                    _hoisted_195,
                    _hoisted_196,
                    _createVNode("td", _hoisted_197, _toDisplayString(_ctx.bca.orderId), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.bca.invoice_number)
                ? (_openBlock(), _createBlock("tr", _hoisted_198, [
                    _hoisted_199,
                    _hoisted_200,
                    _createVNode("td", _hoisted_201, _toDisplayString(_ctx.bca.invoice_number), 1)
                  ]))
                : _createCommentVNode("", true),
              _createVNode("tr", null, [
                (_ctx.bca.va_number_nobill === '')
                  ? (_openBlock(), _createBlock("td", _hoisted_202, "Nomor Va"))
                  : (_openBlock(), _createBlock("td", _hoisted_203, "Nomor Va 1")),
                _hoisted_204,
                _createVNode("td", _hoisted_205, [
                  _createTextVNode(_toDisplayString(_ctx.bca.bank_name) + " " + _toDisplayString(_ctx.bca.va_number) + " ", 1),
                  _createVNode("ion-icon", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.copyValue(_ctx.bca.va_number))),
                    name: "copy-outline"
                  })
                ])
              ]),
              (_ctx.bca.va_number_nobill !== '')
                ? (_openBlock(), _createBlock("tr", _hoisted_206, [
                    _hoisted_207,
                    _hoisted_208,
                    _createVNode("td", _hoisted_209, [
                      _createTextVNode(_toDisplayString(_ctx.bca.bank_name) + " " + _toDisplayString(_ctx.bca.va_number_nobill) + " ", 1),
                      _createVNode("ion-icon", {
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.copyValue(_ctx.bca.va_number))),
                        name: "copy-outline"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("tr", null, [
                _hoisted_210,
                _hoisted_211,
                _createVNode("td", _hoisted_212, _toDisplayString(_ctx.formatPrice(_ctx.bca.amount)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_213,
                _hoisted_214,
                _createVNode("td", _hoisted_215, _toDisplayString(_ctx.formatPrice(_ctx.bca.convenience_fee)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_216,
                _hoisted_217,
                _createVNode("td", _hoisted_218, _toDisplayString(_ctx.formatPrice(_ctx.bca.merchant_fee)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_219,
                _hoisted_220,
                _createVNode("td", _hoisted_221, "-" + _toDisplayString(_ctx.formatPrice(_ctx.bca.total_discount)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_222,
                _hoisted_223,
                _createVNode("td", _hoisted_224, _toDisplayString(_ctx.formatPrice(_ctx.bca.ppn)), 1)
              ]),
              _createVNode("tr", null, [
                _hoisted_225,
                _hoisted_226,
                _createVNode("td", _hoisted_227, [
                  _createVNode("b", null, _toDisplayString(_ctx.formatPrice(_ctx.bca.total_payment)), 1)
                ])
              ])
            ]),
            (_ctx.canUploadReference)
              ? (_openBlock(), _createBlock("hr", _hoisted_228))
              : _createCommentVNode("", true),
            (_ctx.canUploadReference)
              ? (_openBlock(), _createBlock("div", _hoisted_229, [
                  _hoisted_230,
                  _createVNode("input", {
                    type: "file",
                    class: "form-control",
                    id: "referenceFile",
                    onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                    accept: "image/*,application/pdf"
                  }, null, 32),
                  _createVNode("div", _hoisted_231, [
                    (_ctx.referenceFile)
                      ? (_openBlock(), _createBlock("div", _hoisted_232, [
                          _createVNode("img", {
                            src: _ctx.referenceFile,
                            class: "img-fluid",
                            style: {"max-height":"400px","max-width":"100%"}
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_233, " Bukti pembayaran tidak tersedia. "))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_234
        ])
      ])
    ]),
    _createVNode("div", _hoisted_235, [
      _createVNode("div", _hoisted_236, [
        _createVNode("div", _hoisted_237, [
          _hoisted_238,
          _createVNode("div", _hoisted_239, [
            _createVNode("table", _hoisted_240, [
              _hoisted_241,
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.refundDetails, (detail, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", null, _toDisplayString(detail.bill_name), 1),
                    _createVNode("td", null, [
                      _createVNode("span", _hoisted_242, _toDisplayString(detail.month), 1)
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", {
                        class: 'badge bg-' + detail.status_color
                      }, _toDisplayString(detail.status), 3)
                    ]),
                    _createVNode("td", null, _toDisplayString(_ctx.formatPrice(detail.amount)), 1)
                  ]))
                }), 128))
              ]),
              _createVNode("tfoot", null, [
                _createVNode("tr", null, [
                  _hoisted_243,
                  _createVNode("td", _hoisted_244, _toDisplayString(_ctx.formatPrice(_ctx.totalRefund)), 1)
                ])
              ])
            ])
          ]),
          _hoisted_245
        ])
      ])
    ]),
    _createVNode("div", _hoisted_246, [
      _createVNode("div", _hoisted_247, [
        _createVNode("div", _hoisted_248, [
          _hoisted_249,
          (_ctx.imported_us_order)
            ? (_openBlock(), _createBlock("div", _hoisted_250, [
                _createVNode("table", _hoisted_251, [
                  _createVNode("tr", null, [
                    _hoisted_252,
                    _hoisted_253,
                    _createVNode("td", _hoisted_254, _toDisplayString(_ctx.imported_us_order.order_id), 1)
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_255,
                    _hoisted_256,
                    _createVNode("td", _hoisted_257, [
                      _createTextVNode(_toDisplayString(_ctx.imported_us_order.merchant.type) + " " + _toDisplayString(_ctx.imported_us_order.custom_field1) + " ", 1),
                      _createVNode("ion-icon", {
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.copyValue(_ctx.imported_us_order.custom_field1))),
                        name: "copy-outline"
                      })
                    ])
                  ]),
                  _createVNode("tr", null, [
                    _hoisted_258,
                    _hoisted_259,
                    _createVNode("td", _hoisted_260, [
                      _createVNode("b", null, _toDisplayString(_ctx.formatPrice(_ctx.imported_us_order.total_payment)), 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.canUploadReference)
            ? (_openBlock(), _createBlock("div", _hoisted_261, [
                _hoisted_262,
                _createVNode("div", _hoisted_263, [
                  _hoisted_264,
                  _createVNode("input", {
                    type: "file",
                    class: "form-control",
                    id: "referenceFile",
                    onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                    accept: "image/*,application/pdf"
                  }, null, 32),
                  _createVNode("div", _hoisted_265, [
                    (_ctx.referenceFile)
                      ? (_openBlock(), _createBlock("div", _hoisted_266, [
                          _createVNode("img", {
                            src: _ctx.referenceFile,
                            class: "img-fluid",
                            style: {"max-height":"400px","max-width":"100%"}
                          }, null, 8, ["src"])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_267, " Bukti pembayaran tidak tersedia. "))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_268
        ])
      ])
    ])
  ], 64))
}